import React, {Component} from "react";
import {connect} from "react-redux";
import {getFormValues} from "redux-form";
import queryString from "query-string";
import isEmpty from "lodash/isEmpty";
/* AppCore */
import {persistPartnerAgreement,} from "../../AppCore";
import { AGREEMENT_PAGE, COMMITMENT_PAGE, SUCCESS_PAGE } from "../assets/js/constants";
import {getSignPad, getSignType, isSignatureEmpty,} from "../../NTICore/component/Signature/selector";

/** Actions */
import * as partnerActions from "../action";
import {fetchPartnerPrefill, trackPreviewOpened} from "../service";
import CommitmentContainer from "./CommitmentContainer";
import {PartnerAgreementInitialState} from "../model";
import Agreement from "../Component/Agreement/Agreement";
import SuccessPageContainer from "./SuccessPageContainer";
import {CustomAlert, SystemErrorState} from "../../AppCore/Component/Notification";
import {PageContent} from "../../AppCore/Component/Layout";
import {HeaderPage} from "../Component/HeaderPage";

class AgreementContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentStep: '',
      commissionRate: 20,
      subSource2: "",
      isFetchingContact: true,
      processingForm: false,
      alertMessage: '',
      alertType: '',
      agreement: PartnerAgreementInitialState.partnerAgreement,
      isPartner: false, // Only apply for Partner that has signed agreement
      downloadFileAvailable: '',
      mondayItemId: '', // the Monday Contact id carried in the sign-up link
      // The linked Partner's own Monday id, once prefill resolves it — null when this
      // Contact has no Partner yet. Preview/sign tracking targets this, never
      // mondayItemId (that's a Contacts-board id, not a Partner one) — see
      // PartnerLeadTrackingService on the backend for why mixing them up breaks it.
      partnerMondayId: null,
    };
  }

  /**
   * Validate if some route matched
   */
  componentDidMount() {
    // Get param from url
    const values = queryString.parse(this.props.location.search);
    this.setState({mondayItemId: values.source});
    this.getContactDataFromHubSpot(values.source);
    /** Set the ref of SignatureCanvas component in sigPad var  */
    this.sigPad = null;
  }

  /**
   * Fetch Lead
   * @param source
   * @returns {Promise<void>}
   */
  getContactDataFromHubSpot = async (source) => {
    if (source) {
      try {
        this.setState({
          isFetchingContact: true,
          alertType: "PROCESSING",
          alertMessage: 'Setting up your data, please wait a moment.'
        });
        const response = await fetchPartnerPrefill(source);
        this.setState({isFetchingContact: false, alertMessage: '', alertType: ''});
        this.populateForm(response.data);
      } catch (e) {
        if (e.code === 404) {
          // The two realistic causes of "the gateway can't find this Contact at
          // all": the link's id is wrong/stale, or this email already completed
          // sign-up somewhere else and the id no longer resolves the same way.
          this.setState({
            isFetchingContact: true,
            alertType: "ERROR",
            alertMessage: "We couldn't find your information. This can happen if the link you used is incorrect or has expired, or if this email is already registered with us."
          });
        }
        else {
          // Manage Errors
          this.setState({
            isFetchingContact: true,
            alertType: "ERROR",
            alertMessage: 'An unexpected error has occurred while setting up your data.'
          });
        }

      }
    } else {
      this.setState({
        isFetchingContact: true,
        alertType: "ERROR",
        alertMessage: "We couldn't find your information. Please confirm the URL you used is correct and complete."
      });
    }
  };

  /**
   * populate form with values came from url
   * @param values
   */
  populateForm = (values) => {

    if (!isEmpty(values)) {
      persistPartnerAgreement(values.email);

      this.setState({
        downloadFileAvailable: values.downloadFileAvailable,
        currentStep: values.nextProcess,
        commissionRate: values.commissionRate,
        bonus: values.bonus,
        subSource2: values.subSource2,
        isPartner: values.isPartner,
        partnerMondayId: values.partnerMondayId,
      });

      // Fires once per page load, right when we know which step the partner is about
      // to see — best-effort, never blocks the flow (trackPreviewOpened swallows its
      // own errors). Uses values.partnerMondayId directly rather than
      // this.state.partnerMondayId, which the setState above hasn't applied yet.
      // trackPreviewOpened no-ops silently when this is null/undefined (this Contact
      // has no linked Partner yet — nothing to track against; the Contact's own id
      // can't stand in for it, see PartnerAgreementService::save() on the backend --
      // Monday rejects a Partners-board write against a Contacts-board item id).
      if (values.nextProcess === AGREEMENT_PAGE) {
        trackPreviewOpened("agreement", values.partnerMondayId);
      } else if (values.nextProcess === COMMITMENT_PAGE) {
        trackPreviewOpened("commitment", values.partnerMondayId);
      }

      // When is a new Lead
      if (values.isPartner === false) {
        this.setState({
          agreement: { ...this.state.agreement, ...values }
        }, () => {
          this.props.setPartnerAgreement(this.state.agreement);
        })
      }
      else {
        this.props.setCommitment({
          partnerAgreement: values.partnerAgreement,
          legalName: values.legalName,
          email: values.email,
        });
      }
    }
  };

  /**
   * Catch all errors in this component
   * @param error
   * @param errorInfo
   */
  componentDidCatch(error, errorInfo) {
    console.log("Error: ", error, "ErrorInfo: ", errorInfo);
  }

  /**
   * Submit form
   * @return {boolean}
   */
  onSubmit = () => {
    this.setState({processingForm: true});

    setTimeout(() => {
      let form = {...this.props.formValues};

      form.signatureName =
        this.props.signType === null ? "" : this.props.signType;
      form.signatureImageBase64 =
        this.props.signPad === null ? "" : this.props.signPad;
      form.commissionRate = this.state.commissionRate;
      form.subSource2 = this.state.subSource2;
      form.state = form.stateWithCountry.shortName;

      this.props.setCommitment({
        partnerAgreement: form,
        email: form.email,
        legalName: form.legalName
      });

      this.setState(
        {currentStep: COMMITMENT_PAGE, agreement: form, processingForm: false},
        () => {
          window.scrollTo(0, 0);
        }
      );
      // populateForm() already tracked this on first load for RETURNING partners who
      // land straight on COMMITMENT_PAGE — this covers the other path, a NEW lead
      // moving from Agreement to Commitment within the same session.
      trackPreviewOpened("commitment", this.state.partnerMondayId);
    }, 2000);
  };

  /**
   *
   * @param data
   * @param result
   * @param downloadFile
   */
  afterSavedCommitment = (data, result, downloadFile) => {
    if (result === true) {
      this.setState(
        {
          currentStep: SUCCESS_PAGE,
          downloadFileAvailable: downloadFile
        },
        () => {
          window.scrollTo(0, 0);
        }
      );
    }
  };

  render() {
    const disabledSubmit = !(this.props.formValues && this.props.formValues.agree);
    const {alertType, alertMessage, isFetchingContact, currentStep, agreement, commissionRate, processingForm, isPartner, downloadFileAvailable} = this.state;

    return (
      <PageContent>
        <HeaderPage policyText={currentStep === AGREEMENT_PAGE ? "LIMITED AGENCY AGREEMENT" : currentStep === COMMITMENT_PAGE ? "PARTNERSHIP COMMITMENT" : ''}/>
        {isFetchingContact === true ?
        (alertType === "ERROR" ?
          <SystemErrorState message={alertMessage}/>
          :
          <CustomAlert type={alertType} message={alertMessage}/>)
        :
        currentStep === AGREEMENT_PAGE ? (
            <Agreement
              submitForm={this.onSubmit}
              disabledSubmit={disabledSubmit}
              partnerLegalName={this.props.partnerLegalName}
              commissionRate={commissionRate}
              processingForm={processingForm}
              errorMessage={this.props.errorMessage}
            />
          ) :
          currentStep === COMMITMENT_PAGE ? (
              <CommitmentContainer agreement={agreement} onCommitmentSaved={this.afterSavedCommitment} isPartner={isPartner} mondayItemId={this.state.mondayItemId} partnerMondayId={this.state.partnerMondayId}/>
            ) :
            currentStep === SUCCESS_PAGE ? (
                <SuccessPageContainer isPartner={isPartner} downloadFileAvailable={downloadFileAvailable}/>
              )
              : null
        }
      </PageContent>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // Get Partner LegalName from model
    partnerLegalName: state.PartnerAgreementReducer.partnerAgreement.legalName,

    // Get form values
    formValues: getFormValues("partnerAgreementForm")(state),
    commitmentFormValues: getFormValues("commitmentForm")(state),

    // Get error
    errorMessage: state.PartnerAgreementReducer.error.errorMessage,

    // Get partnerAgreement ID to download PDF
    agreementId: state.PartnerAgreementReducer.partnerAgreement.id,

    // Get values from Signature Selector API
    signPad: getSignPad(state),
    signType: getSignType(state),
    isSignatureEmpty: isSignatureEmpty(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // Form Action
    // onCreatePartnerAgreement: (form, context, callback) => dispatch(partnerActions.createPartnerAgreement(form, context, callback)),
    onCreatePartnerAgreement: (form) =>
      dispatch(partnerActions.createPartnerAgreement(form)),

    // Send Message to partner
    onSentMessageToPartner: (id) =>
      dispatch(partnerActions.sentMessageToPartner(id)),

    // Send Message to internal ceo
    onSentMessageToInternalCEO: (id) =>
      dispatch(partnerActions.sentMessageToInternalCEO(id)),

    // Set partner agreement model data
    setPartnerAgreement: (partner) =>
      dispatch(partnerActions.setPartnerAgreement(partner)),

    // Set commitment model data
    setCommitment: (data) =>
      dispatch(partnerActions.setCommitment(data)),

    // TODO: Routes Actions
    goToSuccessFormRoute: () => dispatch(partnerActions.successForm()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AgreementContainer);



// WEBPACK FOOTER //
// ./src/modules/PartnerAgreement/Container/AgreementContainer.js